import { render } from "./ClientsList.vue?vue&type=template&id=7612c4f2&scoped=true"
import script from "./ClientsList.vue?vue&type=script&lang=js"
export * from "./ClientsList.vue?vue&type=script&lang=js"

import "./ClientsList.vue?vue&type=style&index=0&id=7612c4f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7612c4f2"]])

export default __exports__